const orIN= {
    login: {
      title: 'ସାଇନ ଇନ',
      sign_in_btn: 'ସାଇନ ଇନ'
    },
    bar: {
        logout: 'ଲଗ ଆଉଟ',
        languages: 'ସମସ୍ତ ଭାଷା',
        settings: 'ସେଟିଙ୍ଗସ ଖୋଲନ୍ତୁ'
    },
    language: {
      name: 'ଓଡ଼ିଆ (ଭାରତ)',
    },
    attributePage: {
        title: 'ଗୁଣଧର୍ମ ପରିବର୍ତ୍ତନ',
        viewChanges: 'ସମସ୍ତ ପରିବର୍ତ୍ତନ ଦେଖନ୍ତୁ',
        dateTime: 'ତାରିଖ',
        notificationType: 'ବିଜ୍ଞପ୍ତି ପ୍ରକାର',
        notificationValue: 'ବିଜ୍ଞପ୍ତି ମୂଲ୍ୟ',
        oldValue: 'ପୁରୁଣା ମୂଲ୍ୟ',
        newValue: 'ନୂତନ ମୂଲ୍ୟ',
        accept: 'ସ୍ୱୀକାର କରନ୍ତୁ',
        reject: 'ପ୍ରତ୍ୟାଖ୍ୟାନ କରନ୍ତୁ',
    },
    Home: 'ମୂଳ ପୃଷ୍ଠା',
    load: 'ପ୍ରାରମ୍ଭିକ ଲୋଡ କରାଯାଉଛି...',
    Requested: "ଅନୁରୋଧ କରଯାଇଛି",
    Viewed: "ଦେଖାଯାଇଛି",
    Executing: "କାର୍ଯ୍ୟକାରୀ କରୁଛି",
    Completed: "ସମ୍ପୂର୍ଣ୍ଣ ହୋଇଛି",
    Expired: "ମିଆଦ ସମାପ୍ତ ହୋଇଯାଇଛି",
    Cancelled: "ବାତିଲ୍‌ ହୋଇଛି",
    Error: "ତ୍ରୁଟି",
    Rejected: "ପ୍ରତ୍ୟାଖ୍ୟାନ କରଯାଇଛି",
    error: 'କିଛି ତ୍ରୁଟି ଘଟିଛି; ପରେ ପୁନଃ ଚେଷ୍ଟା କରନ୍ତୁ ।',
    displayname: 'ପ୍ରଦର୍ଶିତ ନାମ',
    givenname: 'ନାମ',
    surname: 'ସାଙ୍ଗିଆ',
    email: 'ଇମେଲ',
    mail: 'ଇମେଲ',
    name: 'ନାମ',
    firstname: 'ନାମ',
    lastname: 'ସାଙ୍ଗିଆ',
    footer_copyright: 'ସର୍ବସ୍ୱତ୍ୱ ସଂରକ୍ଷିତ ।'
  };
  
  export default orIN;
  